<script lang="ts">
  import { browser } from '$app/environment';
  import { portal } from '$lib/actions/portal';

  export let showModal = false;
  export let height = '95vh';
  const isOpen = false;

  $: if (showModal && browser) {
    document.body.style.overflow = 'hidden';
  } else if (!showModal && browser) {
    document.body.style.overflow = 'auto';
  }
</script>

{#if showModal}
  <dialog class="modal-overlay" use:portal={'#portal'} style="--height:{height};">
    <slot />
  </dialog>
{/if}

<style lang="scss">
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: var(--z-index-zodiac-modal);
    border: none;
    background: rgb(41 42 45 / 83%);
  }
</style>
